<template>
  <div
    class="error-notification"
    :class="{ 'show-notification': errorCode !== null }"
  >
    <span class="cm-icon cm-icon-warning-open" aria-hidden="true"></span>
    {{ $t(`paymentdetails.cards.errors.${errorCode}`) }}
  </div>
</template>
<script>
export default {
  name: "errorNotification",
  props: ["errorCode"],
};
</script>
